import React, { useContext } from "react";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import { isEmpty, getDwk, isToday, getTimeText } from "bodycodi/cmap/app/js/common";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import icon_next from "bodycodi/cmap/app/svg/icon_next.svg";

type AddScheduleStepProp = {
  data: any;
  updateData: any;
  startTime: any;
  endTime: any;
};

const AddScheduleStep = ({ data, updateData, startTime, endTime }: AddScheduleStepProp) => {
  const { partnerName, partnerBranchName } = useSelector((state: RootState) => state.partner);
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);
  const { scheduleType, chooseDate, member, editStep } = data;
  const timeTextEtc = `${getTimeText(startTime)} - ${getTimeText(endTime)}`;

  const clickNextStep = () => {
    if (editStep === 1) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "EDIT_ETC_TIME_PICKER_POP",
        open: { editEtcTimePickerPop: true },
      });
      updateData({ editStep: 2 });
      return;
    }
    if (scheduleType === "CS") {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CONFIRM_CONDITION_CS_UPD",
        open: { cofirmConditionCsUpd: true },
      });
    } else if (scheduleType === "OT") {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CONFIRM_CONDITION_OT_UPD",
        open: { cofirmConditionOtUpd: true },
      });
    } else if (scheduleType === "ET") {
      dispatch({
        type: "POP_UP_OPEN",
        id: "CONFIRM_CONDITION_ET_UPD",
        open: { cofirmConditionEtUpd: true },
      });
    }
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_TIME_PICKER_UPD_POP",
      open: { chooseTimePickerUpdPop: false },
    });
  };

  const clickPrevStep = () => {
    if (editStep === 1) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "EDIT_ETC_CALENDAR_POP",
        open: { editEtcCalendarPop: false },
      });
    } else if (editStep === 2) {
      dispatch({
        type: "POP_UP_OPEN",
        id: "EDIT_ETC_TIME_PICKER_POP",
        open: { editEtcTimePickerPop: false },
      });
      updateData({ editStep: 1 });
    }
  };

  if (!state.isShowBottom) {
    return <></>;
  }

  return (
    <div className="add-schedule-center-confirm">
      {scheduleType === "CS" && (
        <>
          <div className="step-top">
            <div className="condition">
              {partnerName} {partnerBranchName}
            </div>
            {!isEmpty(member) && <div className="condition">{member.name} - 상담 스케줄</div>}
            {!isEmpty(chooseDate) && (
              <>
                <div className="condition">
                  {chooseDate.month}. {chooseDate.date}.{" "}
                  {getDwk(
                    new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay()
                  )}{" "}
                  {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                  {!isEmpty(startTime) && !isEmpty(endTime) && editStep === 2 && (
                    <> &#183; {timeTextEtc}</>
                  )}
                </div>
              </>
            )}
          </div>
        </>
      )}
      {scheduleType === "OT" && (
        <>
          <div className="step-top">
            <div className="condition">
              {partnerName} {partnerBranchName}
            </div>
            {!isEmpty(member) && <div className="condition">{member.name} - 상담 스케줄</div>}
            {!isEmpty(chooseDate) && (
              <>
                <div className="condition">
                  {chooseDate.month}. {chooseDate.date}.{" "}
                  {getDwk(
                    new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay()
                  )}{" "}
                  {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                  {!isEmpty(startTime) && !isEmpty(endTime) && editStep === 2 && (
                    <> &#183; {timeTextEtc}</>
                  )}
                </div>
              </>
            )}{" "}
          </div>
        </>
      )}
      {scheduleType === "ET" && (
        <>
          <div className="step-top">
            <div className="condition">
              {partnerName} {partnerBranchName}
            </div>
            {!isEmpty(chooseDate) && (
              <>
                <div className="condition">
                  {chooseDate.month}. {chooseDate.date}.{" "}
                  {getDwk(
                    new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay()
                  )}{" "}
                  {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                  {!isEmpty(startTime) && !isEmpty(endTime) && editStep === 2 && (
                    <> &#183; {timeTextEtc}</>
                  )}
                </div>
              </>
            )}
          </div>
        </>
      )}
      <div className="btn-group">
        <div className="btn left white" onClick={clickPrevStep}>
          이전
        </div>
        {editStep === 1 && (
          <div className="btn right blue" onClick={clickNextStep}>
            시간ㆍ내용 입력
            <img src={icon_next} />
          </div>
        )}
        {editStep === 2 && (
          <div className="btn right blue" onClick={clickNextStep}>
            변경하기
          </div>
        )}
      </div>
    </div>
  );
};

export default AddScheduleStep;
